import AsosView from '../AsosView.vue'

export const asosRoute = [
  {
    path: '/holerites',
    name: 'asos',
    component: AsosView,
    meta: {
      key: 'view_docs'
    }
  }
]
